'use strict';

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _adapter = require('./adapter');

var _adapter2 = _interopRequireDefault(_adapter);

var _queryString = require('query-string');

var _queryString2 = _interopRequireDefault(_queryString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var adapter = new _adapter2.default();

var TOKEN_NAME = '_mini_a';
var BEAST_ID = '_mini_b';
var MEMBER_NAME = '_mini_m';
var TBS_USOURCE_NAME = '_mini_w';
var LOGGED_ERROR = '_mini_login_err';
var QUERY_REFERRER_NAME = '_mini_ref';

var queryMap = _queryString2.default.parse(window.location.search.slice(1));
var query = {};
(0, _keys2.default)(queryMap).map(function (name) {
  try {
    query[name] = name === MEMBER_NAME ? queryMap[name] : atob(queryMap[name]);
  } catch (e) {
    query[name] = queryMap[name];
  }
});

var vm = void 0;

function setVue(v) {
  vm = v;
}

function getVue() {
  return vm;
}

function getEnv() {
  return new _promise2.default(function (resolve) {
    adapter.invoke(function () {
      resolve(adapter.env);
    });
  });
}

module.exports = {
  adapter: adapter,
  TOKEN_NAME: TOKEN_NAME,
  BEAST_ID: BEAST_ID,
  LOGGED_ERROR: LOGGED_ERROR,
  MEMBER_NAME: MEMBER_NAME,
  TBS_USOURCE_NAME: TBS_USOURCE_NAME,
  QUERY_REFERRER_NAME: QUERY_REFERRER_NAME,
  query: query,
  setVue: setVue,
  getVue: getVue,
  getEnv: getEnv
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@beastshop/sdk/lib/lib/util.js
// module id = 542
// module chunks = 0